import { render, staticRenderFns } from "./license_issue_body.vue?vue&type=template&id=494f6e31&"
import script from "./license_issue_body.vue?vue&type=script&lang=js&"
export * from "./license_issue_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "license_issue_body.vue"
export default component.exports